import rbwReady from './meet_rbw_ready.js'

export default () => {
  return rbwReady()
}
